import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3e114022 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _8d65bf20 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _612ac630 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _e13a0e4a = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _cbb8f4d2 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _1b98b780 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _2b6f574c = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _a4abc360 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _1e99a1d2 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _6fd63908 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _c7396e86 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _00a00506 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _05ccf128 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _fa459582 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _5bd6fda0 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _54f84656 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _df292376 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _cbb7a080 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _147d35e6 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _18a65c55 = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _3e114022,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _8d65bf20,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _612ac630,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _e13a0e4a,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _cbb8f4d2,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _1b98b780,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _1b98b780,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _1b98b780,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _2b6f574c,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _a4abc360,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _1e99a1d2,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _a4abc360,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _1e99a1d2,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _6fd63908,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _6fd63908,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _6fd63908,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _6fd63908,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _6fd63908,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _6fd63908,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _6fd63908,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _c7396e86,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _c7396e86,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _00a00506,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _05ccf128,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _05ccf128,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _fa459582,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _5bd6fda0,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _54f84656,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _54f84656,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _df292376,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _cbb7a080,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _147d35e6,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _18a65c55,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
